import { View } from "react-native";
import { paddingLarge } from "src/styles/spacing";
import { Text } from "src/swsh-native";

const GatheringPrivacyBlurb = ({ title, description }: { title: string; description: string }) => {
	return (
		<View
			style={{
				flexDirection: "row",
				justifyContent: "space-between",
				alignItems: "center",
				marginVertical: paddingLarge,
			}}
		>
			<View
				style={{
					paddingRight: paddingLarge,
					flex: 1,
				}}
			>
				<Text bold>{title}</Text>
				<Text color="TextLight">{description}</Text>
			</View>
		</View>
	);
};
export default GatheringPrivacyBlurb;
